export const generateNumericId = () => {
  return Math.floor(Math.random() * 1000000000);
};
